var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgApplicationDoneOutlined = function SvgApplicationDoneOutlined(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#7E89A1",
    clipPath: "url(#applicationDoneOutlined_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.668 6.557c0-.366-.3-.666-.667-.666H6.335c-.367 0-.667.3-.667.666s.3.667.667.667H13c.367 0 .667-.3.667-.667M6.335 8.805c-.367 0-.667.3-.667.666s.3.667.667.667h3.1c.366 0 .666-.3.666-.667 0-.366-.3-.666-.666-.666z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.134 16.143H5.61a1.293 1.293 0 0 1-1.291-1.292V5.109c0-.716.583-1.291 1.291-1.291h8.109c.708 0 1.291.583 1.291 1.291v3.975c.484.167.934.417 1.334.717V5.109a2.625 2.625 0 0 0-2.625-2.625H5.609A2.625 2.625 0 0 0 2.984 5.11v9.742a2.625 2.625 0 0 0 2.625 2.625h4.634a4.9 4.9 0 0 1-1.117-1.333z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.668 9.633a4.2 4.2 0 0 0-4.191 4.192 4.2 4.2 0 0 0 4.191 4.191 4.2 4.2 0 0 0 4.192-4.191 4.2 4.2 0 0 0-4.192-4.192m0 7.217a3.03 3.03 0 0 1-3.025-3.026 3.03 3.03 0 0 1 3.025-3.024 3.03 3.03 0 0 1 3.025 3.024 3.03 3.03 0 0 1-3.025 3.025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.632 12.566a.58.58 0 0 0-.825.008l-1.675 1.717-.541-.625a.59.59 0 0 0-.825-.058.59.59 0 0 0-.059.825l.959 1.108c.108.125.258.2.425.2h.016a.6.6 0 0 0 .417-.175L15.65 13.4a.58.58 0 0 0-.008-.824z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "applicationDoneOutlined_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.5 0h20v20H.5z"
  })))));
};
export default SvgApplicationDoneOutlined;